import React, { useState } from "react";
import axiosInstance from "../../../utils/axiosInstance";

const LoginImageModal = ({ setShowAddImageModal, setReload }) => {
  const [error, setError] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleImageUpload = async (file) => {
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      await axiosInstance.post("/login/image-upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(progress);
        },
      });

      setShowAddImageModal(false);
      setUploadProgress(0);
      setReload(true);
    } catch (err) {
      setError(err.response.data.message);
      setUploadProgress(0);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      handleImageUpload(file);
    }
  };

  const handleCloseImageModal = () => {
    setShowAddImageModal(false);
    setUploadProgress(0);
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-md p-6 rounded-[22px] border border-gray-200 bg-white shadow-lg shadow-gray-900/5 dark:border-[#2c2c2e] dark:bg-[#1c1c1e] dark:shadow-black/40">
        <h2 className="mb-4 text-lg font-bold text-gray-900 dark:text-white">Upload Image Solution</h2>
        <label className="flex h-40 w-full cursor-pointer items-center justify-center rounded-[18px] border-2 border-dashed border-gray-300 transition hover:border-red-400/60 dark:border-[#3a3a3d]">
          <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-4xl font-extrabold text-transparent">+</span>
          <input type="file" className="hidden" onChange={handleFileChange} />
        </label>
        {uploadProgress > 0 && (
          <div className="mt-4 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-[#2a2a2c]">
            <div
              className="h-4 rounded-full"
              style={{
                width: `${uploadProgress}%`,
                backgroundColor:
                  uploadProgress < 50
                    ? "red"
                    : uploadProgress < 80
                    ? "yellow"
                    : "green",
              }}
            ></div>
          </div>
        )}
        {error && <p className="mt-4 text-sm font-medium text-rose-600 dark:text-rose-400">{error}</p>}
        <div className="flex justify-end space-x-4 mt-4">
          <button
            className="inline-flex h-11 items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-5 text-sm font-semibold text-gray-700 transition hover:border-red-400/60 disabled:opacity-60 dark:border-[#3a3a3d] dark:bg-[#262628] dark:text-slate-200"
            onClick={handleCloseImageModal}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginImageModal;
